import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';
import dateSelect from '@/components/date/dateSelect';
import weekSelect from '@/components/date/weekSelect';
import monthSelect from '@/components/date/monthSelect';
import quarterSelect from '@/components/date/quarterSelect';
import yearSelect from '@/components/date/yearSelect';
import yearRange from '@/components/date/yearRange';
/*const options = [
  { label: '一般故障', value: '1' },
  { label: '严重故障', value: '2' },
]*/

var parentWidth = '160px';
var childWidth = '80px';
export default {
  name: 'WaterReport',
  mixins: [GetSiteIdMixin, JeecgListMixin],
  components: {
    dateSelect: dateSelect,
    weekSelect: weekSelect,
    monthSelect: monthSelect,
    quarterSelect: quarterSelect,
    yearSelect: yearSelect,
    yearRange: yearRange
  },
  data: function data() {
    return {
      minList: {},
      maxList: {},
      avgList: {},
      columns: [],
      autoLoadInit: false,
      scroll: {
        y: 500
      },
      // 展示列表
      columns1: [{
        title: '监测时间',
        align: 'center',
        width: '50px',
        dataIndex: 'dateStr',
        colName: 'date_Str'
      }, {
        title: '待处理',
        align: 'center',
        width: '80px',
        children: [{
          title: '单数',
          align: 'center',
          width: '80px',
          dataIndex: 'waitingNum',
          customRender: function customRender(text, record, index) {
            return text;
          }
        }]
      }, {
        title: '处理中',
        align: 'center',
        width: '80px',
        children: [{
          title: '单数',
          align: 'center',
          width: '80px',
          dataIndex: 'processingNum',
          customRender: function customRender(text, record, index) {
            return text;
          }
        }]
      }, {
        title: '已处理',
        align: 'center',
        width: '80px',
        children: [{
          title: '单数',
          align: 'center',
          width: '80px',
          dataIndex: 'completedNum',
          customRender: function customRender(text, record, index) {
            return text;
          }
        }]
      }
      /*{
        title: '监测时间',
        align: 'center',
        width: '150px',
        dataIndex: 'dateStr',
        colName: 'date_Str'
      },
      {
        title: '反馈人',
        align: 'center',
        width: '150px',
        dataIndex: 'userName'
      },
      {
        title: '反馈时间',
        align: 'center',
        width: '150px',
        dataIndex: 'feedDate'
      },
      {
        title: '联系电话',
        align: 'center',
        width: '150px',
        dataIndex: 'tel'
      },
      {
        title: '反馈次数',
        align: 'center',
        width: '150px',
        dataIndex: 'frequency'
      },
      {
        title: '问题和意见',
        align: 'center',
        width: '150px',
        dataIndex: 'remark'
      },
      {
        title: '状态',
        align: 'center',
        width: '150px',
        dataIndex: 'status',
        customRender: (text, record, index) => {
          if (record.status == 1) {
            return '待处理'
          } else if (record.status == 2) {
            return '工单处理中'
          } else if (record.status == 3) {
            return '已处理'
          } else {
            return '-'
          }
        }
      }*/
      ],
      currentKey: '1',
      url: {
        list: '/om/feed/back/report',
        exportXlsUrl: '/om/feed/back/exportXlsForFeedBack',
        importExcelUrl: '/om/feed/back/importExcel'
      },

      /* options,*/
      value: ['1'],
      reportType: '2',
      limitSelectDate: {},
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },

      /* 柱状图*/
      legendData: [],
      seriesData: [],
      xAxisData: [],
      callbackKey2: {}
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
    this.queryParam.flag = '2';
    this.columns = this.columns1;
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.siteId = ids[1];
      this.queryParam.scope = ids[0];
      this.dataSource = [];
      this.loadData(this.reportType);
      /*this.loadData(3)*/
    }
  },
  methods: {
    drawChart1: function drawChart1() {
      var myEchart = this.$echarts.init(document.getElementById('histogramMain'));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: this.legendData
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        title: {
          text: 'Histogram',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#ccc'
          }
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: this.seriesData
      };
      myEchart.setOption(option);
    },
    callback: function callback(key) {
      if (key === '2') {
        this.currentKey = key; // this.drawChart1()

        this.loadData(this.reportType, this.currentKey);
        this.$msgbox;
      } else if (key === '1') {
        this.currentKey = '1';
        this.visible = true;
      }
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon: function expandIcon(props) {
      var h = this.$createElement;

      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return h("a", {
              "style": "color: 'black',margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "attrs": {
                "type": "caret-down"
              }
            })]);
          } else {
            return h("a", {
              "style": "color: 'black' ,margin-right:0px",
              "on": {
                "click": function click(e) {
                  props.onExpand(props.record, e);
                }
              }
            }, [h("a-icon", {
              "style": "color:red",
              "attrs": {
                "type": "caret-right"
              }
            })]);
          }
        } else {
          return h("span", {
            "style": "margin-right:0px"
          });
        }
      }
    },
    searchQuery: function searchQuery() {
      this.dataSource = [];
      this.loadData(this.reportType, this.currentKey);
      /*this.loadData(3)*/
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      if (record.amount) {
        return record.amount;
      } else {
        return record.fee;
      }
    },
    loadData: function loadData(type, currentKey) {
      var _this = this;

      if (!this.queryParam.stime || !this.queryParam.etime) {
        this.$message_custom('请选择时间', 'error');
        return;
      }

      this.queryParam.type = type;
      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this.seriesData = [];
          _this.xAxisData = [];
          var dataSource = res.result.records; // 柱状图
          // this.reportType == 1 ? this.loadChartData(dataSource) :

          if (currentKey == 2) {
            _this.loadChartData(dataSource);
          } else {
            _this.loadChartChildrenData(dataSource);
          }
          /*dataSource.push(res.result.min)
          dataSource.push(res.result.max)
          dataSource.push(res.result.avg)*/
          // console.log(dataSource)


          _this.$forceUpdate();
          /* todo 月渲染 问题*/


          _this.dataSource = dataSource;

          if (_this.reportType == 3) {
            setTimeout(function () {
              this.dataSource = dataSource;
            }, 2000);
          }
        }

        if (res.code === 510) {
          _this.$message_custom(res.message, 'warning');
        }

        _this.loading = false;
      });
    },
    // 加载图表数据
    loadChartData: function loadChartData(record) {
      var that = this;
      var arr1 = [];
      var arr2 = [];
      var arr3 = [];
      var arr4 = [];
      that.legendData = ['总条数', '待处理', '处理中', '已处理'];
      that.seriesData = [{
        name: '总条数',
        data: arr4,
        type: 'bar',
        stack: '处理状态',
        emphasis: {
          focus: 'series'
        },
        barCategoryGap: '30%' //柱图宽度 投放数量

      }, {
        name: '待处理',
        data: arr1,
        type: 'bar',
        stack: '处理状态',
        emphasis: {
          focus: 'series'
        },
        barCategoryGap: '30%' //柱图宽度 投放数量

      }, {
        name: '处理中',
        data: arr2,
        type: 'bar',
        stack: '处理状态',
        emphasis: {
          focus: 'series'
        },
        barCategoryGap: '30%' //柱图宽度 投放数量

      }, {
        name: '已处理',
        data: arr3,
        type: 'bar',
        stack: '处理状态',
        emphasis: {
          focus: 'series'
        },
        barCategoryGap: '30%' //柱图宽度 投放数量

      }];
      var chartData = record.filter(function (item, idx) {
        return item != undefined;
      });
      chartData.forEach(function (item, index) {
        that.xAxisData.push(item.dateStr);

        if (item.waitingNum) {
          arr1.push(item.waitingNum);
        } else {
          arr1.push(0);
        }

        if (item.processingNum) {
          arr2.push(item.processingNum);
        } else {
          arr2.push(0);
        }

        if (item.completedNum) {
          arr3.push(item.completedNum);
        } else {
          arr3.push(0);
        }

        if (item.frequency) {
          arr4.push(item.frequency);
        } else {
          arr4.push(0);
        }
      });
      /*if (0 < chartData.length) {
        chartData.forEach((item, index) => {
          that.xAxisData.push(item.dateStr)
          if (item.children.length > 0) {
            /!* 每日次数：合并同等级故障次数*!/
            var obj = that.countFilter1(item)
            /!* 每日次数*!/
            arr1.push(obj.countA)
            arr2.push(obj.countB)
          } else {
            arr1.push(0)
            arr2.push(0)
          }
        })
      }*/

      this.drawChart1();
    },
    // 加载子孙图表数据
    loadChartChildrenData: function loadChartChildrenData(record) {
      var _this2 = this;

      var that = this;
      var chartData = record.filter(function (item, idx) {
        return item != undefined;
      });

      if (0 < chartData.length) {
        var param = [];
        chartData.forEach(function (item, index1) {
          that.xAxisData.push(item.dateStr);

          if (item.children.length > 0) {
            /* 每日次数：合并同等级故障次数*/
            var obj = that.countFilter2(item);
            item.children.forEach(function (i, index2) {
              that.legendData = ['一般故障', '严重故障'];
              var arr = [];
              /* 前面没数据的用0填充*/

              for (var j = 0; j < index1; j++) {
                arr.push(0);
              }
              /* 每日次数*/


              if (i.faultLevel == 1) {
                arr.push(obj.countA);
              } else if (i.faultLevel == 2) {
                arr.push(obj.countB);
              }

              var item = {
                name: i.faultLevel == 1 ? '一般故障' : '严重故障',
                data: arr,
                type: 'bar',
                stack: _this2.reportType == 2 ? '' : '故障级别',
                emphasis: {
                  focus: 'series'
                },
                barCategoryGap: '30%',
                //柱图宽度 投放数量
                index: i.createTime
              };

              if (param.length > 0) {
                param.forEach(function (i, index3) {
                  /* 合并同组但不同天的数据*/
                  if (i.name == item.name) {
                    var s = item.data.slice(i.data.length, item.data.length);
                    i.data = i.data.concat(s);
                  }
                });
              }
              /* 限制2组数据*/


              if (param.length < 2) {
                param.push(item);
              }
              /* 过滤*/


              param = that.deteleObject(param);
            });
          }

          that.seriesData = param;
        });
      } // that.drawChart1()

    },

    /* 过滤*/
    deteleObject: function deteleObject(obj) {
      var uniques = [];
      var stringify = {};

      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = '';

        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }

        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }

      uniques = uniques;
      return uniques;
    },

    /* 计算每日次数*/
    countFilter1: function countFilter1(value) {
      var countA = 0;
      var countB = 0;

      if (value.children.length > 0) {
        value.children.forEach(function (i, index2) {
          i.faultLevel == 1 ? countA++ : countB++;
        });
      }

      return {
        countA: countA,
        countB: countB
      };
    },
    countFilter2: function countFilter2(value) {
      var countA = 0;
      var countB = 0;
      value.children.forEach(function (i, index) {
        i.faultLevel == 1 ? countA++ : countB++;
      });
      return {
        countA: countA,
        countB: countB
      };
    },
    // 日期变化
    dateChange: function dateChange(value) {
      console.log('日期变化', value);
      this.queryParam.quantum = value;
      this.searchQuery();
    },
    // 周变化
    weekChange: function weekChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
      console.log('周变化', value); // [年,周]

      this.searchQuery();
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
      console.log('月变化', value);
      this.searchQuery();
    },
    // 季度变化
    quarterChange: function quarterChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
      console.log('季度变化', value); // [年,季度]
    },
    // 年变化
    yearChange: function yearChange(value) {
      this.queryParam.quantum = value;
      console.log('年变化', value);
    },
    // 年区间变化
    yearRangeChange: function yearRangeChange(value) {
      this.queryParam.stime = value[0];
      this.queryParam.etime = value[1];
      console.log('年区间变化', value);
    },
    // 报表类型变化
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;

      if (this.reportType == '8') {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    // 故障等级变化
    onChange: function onChange(checkedValues) {
      if (checkedValues.length > 1) {
        this.queryParam.flag = '3';
        this.columns = _toConsumableArray(this.columns1);
        this.scroll = {
          y: 460
        };
      } else {
        this.scroll = {
          y: 500
        };

        if (checkedValues[0] == '1') {
          this.queryParam.flag = '2';
          this.columns = _toConsumableArray(this.columns3);
        } else if (checkedValues[0] == '2') {
          this.queryParam.flag = '1';
          this.columns = _toConsumableArray(this.columns2);
        } else {
          this.queryParam.flag = '3';
          this.columns = _toConsumableArray(this.columns1);
          this.scroll = {
            y: 460
          };
        }
      }

      this.loadData(this.reportType, this.currentKey);
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    }
  }
};